(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compact-newsletter"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.compact-newsletter__form';
  const revision = '2026-07-15';

  const bindForm = (form) => {
    if (form.dataset.klaviyoDirectBound === 'true') return;

    const consentForm = form.querySelector('newsletter-consent-form');
    if (!consentForm) return;

    form.dataset.klaviyoDirectBound = 'true';

    form.addEventListener('submit', async (event) => {
      if (form.dataset.klaviyoPassThrough === 'true') {
        delete form.dataset.klaviyoPassThrough;
        return;
      }

      const publicKey = (consentForm.dataset.klaviyoPublicKey || '').trim();
      const listId = (consentForm.dataset.klaviyoListId || '').trim();

      if (!publicKey && !listId) return;

      if (!publicKey || !listId) {
        console.warn('Compact newsletter: both Klaviyo Public API Key / Site ID and Klaviyo List ID are required. Shopify signup will continue without direct Klaviyo list subscription.');
        return;
      }

      const consentCheckbox = consentForm.querySelector('[data-newsletter-consent-checkbox]');
      const requiresConsent = consentForm.hasAttribute('require-consent');

      if (requiresConsent && consentCheckbox && !consentCheckbox.checked) return;

      const emailInput = form.querySelector('[name="contact[email]"]');
      const email = emailInput?.value?.trim();
      if (!email) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
      if (submitter) submitter.setAttribute('disabled', 'disabled');
      form.setAttribute('aria-busy', 'true');

      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 8000);

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(publicKey)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'revision': revision
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Shopify Compact newsletter',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId
                  }
                }
              }
            }
          }),
          signal: controller.signal
        });

        if (!response.ok) {
          let errorDetail = '';
          try {
            errorDetail = await response.text();
          } catch (error) {
            errorDetail = String(error);
          }
          console.error(`Compact newsletter: Klaviyo subscription failed (${response.status}).`, errorDetail);
        }
      } catch (error) {
        console.error('Compact newsletter: Klaviyo subscription request failed. Shopify signup will continue.', error);
      } finally {
        window.clearTimeout(timeoutId);
        form.removeAttribute('aria-busy');
        if (submitter) submitter.removeAttribute('disabled');

        form.dataset.klaviyoPassThrough = 'true';
        if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
      }
    }, true);
  };

  const bindAll = (root = document) => {
    root.querySelectorAll(selector).forEach(bindForm);
  };

  bindAll();
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youtube-video-carousel')) {
    customElements.define(
      'youtube-video-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-viewport]');
          this.cards = [...this.querySelectorAll('[data-card]')];
          this.previousButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          this.dots = this.querySelector('[data-dots]');
          this.controls = this.querySelector('[data-controls]');

          if (!this.viewport || !this.cards.length || !this.previousButton || !this.nextButton || !this.dots || !this.controls) return;

          this.index = 0;
          this.previousButton.addEventListener('click', () => this.goToItem(this.index - 1));
          this.nextButton.addEventListener('click', () => this.goToItem(this.index + 1));

          this.resizeObserver = new ResizeObserver(() => this.keepItemVisible(false));
          this.resizeObserver.observe(this);
          this.refresh();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        refresh() {
          this.index = Math.max(0, Math.min(
this.index, this.cards.length - 1));
          this.dots.replaceChildren();

          this.cards.forEach((card, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'tap-area';
            button.setAttribute('aria-label', String(index + 1));
            button.addEventListener('click', () => this.goToItem(index));
            this.dots.append(button);
          });

          this.controls.hidden = this.cards.length <= 1;
          this.updateControls();
        }

        goToItem(index) {
          const itemCount = this.cards.length;
          this.index = (index + itemCount) % itemCount;
          this.updateControls();
          this.keepItemVisible(true);
        }

        keepItemVisible(smooth) {
          const card = this.cards[this.index];
          if (!card) return;

          const viewportLeft = this.viewport.scrollLeft;
          const viewportRight = viewportLeft + this.viewport.clientWidth;
          const cardLeft = card.offsetLeft;
          const cardRight = cardLeft + card.offsetWidth;
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          let targetLeft = viewportLeft;

          if (cardLeft < viewportLeft) {
            targetLeft = cardLeft;
          } else if (cardRight > viewportRight) {
            targetLeft = cardRight - this.viewport.clientWidth;
          }

          this.viewport.scrollTo({
            left: Math.max(0, Math.min(targetLeft, maxScroll)),
            behavior: smooth ? 'smooth' : 'auto'
          });
        }

        updateControls() {
          [...this.dots.children].forEach((button, index) => {
            button.setAttribute('aria-current', index === this.index ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
